/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.zdroje-grid.title",
    defaultMessage: "Resources"
  },
  add: {
    id: "b2b.zdroje-grid.add",
    defaultMessage: "Add resource"
  }
});

export default () => useMessages(MESSAGES);
